import React, {PropTypes} from 'react';
import axios from './../../../../constants/axios';
import {Table} from 'react-bootstrap';
import {Link} from 'react-router';
import Barcode from 'react-barcode';
import './PurchaseInvoiceDetailItem.less';

class PurchaseInvoiceDetailItem extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceItems: [],
         barcodeWidth: 0.7,
         barcodeHeight: 28,
         barcodeFontSize: 12,

         printPriceList: false,
         printProductList: true,
         printBarcodeList: false,
         printDetails: false,
      };
   }

   componentDidMount = () => {
      const {invoiceId} = this.props.params;
      axios.get(`inventoryPurchases/getInventoryItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceItems: res.data
            });
         });
   };

   changePrintStatus = (event, inputName) => {
      this.setState({
         [inputName]: !this.state[inputName]
      });
   };

   changeBarcodePrintUnit = (event, item) => {
      const {invoiceItems} = this.state;
      const newInvoiceItems = invoiceItems.map((i) => {
         if (i.id === item.id) {
            return Object.assign({}, i, {
               printBarcodeUnit: event.target.value,
            });
         }
         return i;
      });
      this.setState({
         invoiceItems: newInvoiceItems,
      });
   };

   render() {
      const {invoiceItems, barcodeHeight, barcodeWidth, barcodeFontSize, printPriceList, printBarcodeList, printProductList} = this.state;
      const renderBarcode = function () {
         let barcodePrintUnit = [];
         invoiceItems.forEach((item) => {
            // look for i.unit
            for (let i = 1; i <= item.printBarcodeUnit; i++) {
               barcodePrintUnit.push(item);
            }
         });
         return barcodePrintUnit.map((item, index) => (
            <div className="barcode" key={index}>
               <span className="mart71">mart71.com</span>
               <Barcode key={index} value={item.barcode}
                        width={barcodeWidth}
                        height={barcodeHeight}
                        fontSize={barcodeFontSize}
               />
               {/*<span className="item_name" >{item.name.substring(0, 10)}</span >*/}
            </div>
         ));
      };
      const itemPriceRepeater = function () {
         let toPrint = [];
         invoiceItems.map((item) => {
            for (let i = 1; i <= item.printBarcodeUnit; i++) {
               toPrint.push({
                  originalPrice: item.mrp === item.discounted_sale_price ? false : item.mrp,
                  discountedPrice: item.discounted_sale_price,
               });
            }
         });
         return toPrint;
      };
      return (
         <div>
            <div className="printOptionZone">
               <p>Print Options</p>
               <div className="printPriceListContainer">
                  <label htmlFor="printPriceList">Print Price</label>
                  <input onChange={(e) => this.changePrintStatus(e, 'printPriceList')} type="checkbox"
                         name="printPriceList"
                         id="printPriceList" checked={printPriceList}/>
               </div>
               <div className="printBarcodeListContainer">
                  <label htmlFor="printBarcodeList">Print Barcode</label>
                  <input onChange={(e) => this.changePrintStatus(e, 'printBarcodeList')} type="checkbox"
                         name="printBarcodeList"
                         id="printBarcodeList" checked={printBarcodeList}/>
               </div>
               <div className="printProductListContainer">
                  <label htmlFor="printProductList">Print Product</label>
                  <input onChange={(e) => this.changePrintStatus(e, 'printProductList')} type="checkbox"
                         name="printProductList"
                         id="printProductList" checked={printProductList}/>
               </div>
            </div>
            <hr/>
            {printProductList &&
            <div className="PurchaseInvoiceDetailItem">
               <h4>Invoice Items</h4>
               <Table className={{"printPriceList": printPriceList}}>
                  <thead>
                  <tr>
                     <th className="hideThis">Item Id</th>
                     <th>Item Name</th>
                     <th>Qty</th>
                     <th>Pur Price</th>

                     <th className="hideThis">MRP</th>
                     <th className="hideThis">MRP Profit</th>
                     <th className="hideThis">MRP Profit %</th>

                     <th className="hideThis">Sale Dis</th>

                     <th className="hideThis">Dis. Price</th>
                     <th className="hideThis">Dis. Profit</th>
                     <th className="hideThis">Dis. Profit %</th>

                     <th>Total:</th>

                     <th className="hideThis">Barcode Print Unit</th>
                  </tr>
                  </thead>
                  <tbody>
                  {invoiceItems.map((item) => (
                     <tr key={item.id}
                         style={{color: item.discounted_sale_price_profit_percentage <= 0 ? 'red' : 'black'}}>
                        <td className="itemId">
                           {item.has_sub_items
                              ?
                              <Link target="_blank"
                                    to={`/product/productMain/edit/${item.mainItemId}`}>{item.id}</Link>
                              :
                              <Link target="_blank" to={`/product/productMain/edit/${item.id}`}>{item.id}</Link>
                           }
                        </td>
                        <td className="itemName">{item.name}</td>
                        <td>{item.unit}</td>
                        <td>{item.price}</td>

                        <td className="hideThis">{item.mrp}</td>
                        <td className="hideThis">{item.mrp_profit}</td>
                        <td className="hideThis">{item.mrp_profit_percentage}</td>

                        <td className="hideThis">{item.discount}</td>

                        <td className="hideThis">{item.discounted_sale_price}</td>
                        <td className="hideThis">{item.discounted_sale_price_profit}</td>
                        <td className="hideThis">{item.discounted_sale_price_profit_percentage}</td>

                        <td>{item.item_total}</td>

                        <td>
                           <input type="number" className="printBarcodeUnit" value={item.printBarcodeUnit}
                                  onChange={(e) => this.changeBarcodePrintUnit(e, item)}/>
                        </td>
                     </tr>
                  ))}
                  </tbody>
               </Table>
            </div>
            }
            <div className="barcodePrintZone">
               {printBarcodeList &&
               renderBarcode()
               }
            </div>
            <hr/>

            {
               printPriceList &&
               <div className="pricePrintContainer">
                  {itemPriceRepeater().map((toPrint, i) => <span className="pricePrint" key={i}>
                  {toPrint.originalPrice && <i>{toPrint.originalPrice} tk.</i>}
                     <b> {toPrint.discountedPrice} tk.</b>
                  </span>)}
               </div>
            }
         </div>
      );
   }
}

PurchaseInvoiceDetailItem.propTypes = {
   params: PropTypes.object
};

export default PurchaseInvoiceDetailItem;

// import React, { PropTypes } from 'react';
// import axios from './../../../../constants/axios';
// import { Table } from 'react-bootstrap';
// import { Link } from 'react-router';
// import Barcode from 'react-barcode';
// import './PurchaseInvoiceDetailItem.less';
//
// class PurchaseInvoiceDetailItem extends React.Component {
//    constructor(props) {
//       super(props);
//       this.state = {
//          invoiceItems: [],
//          barcodeWidth: 0.7,
//          barcodeHeight: 28,
//          barcodeFontSize: 12,
//
//          onlyPrintPrice: false,
//       };
//    }
//
//    componentDidMount() {
//       const { invoiceId } = this.props.params;
//       axios.get(`inventoryPurchases/getInventoryItemsByInvoiceId/${invoiceId}`)
//          .then((res) => {
//             this.setState({
//                invoiceItems: res.data
//             });
//          });
//    }
//
//    changeOnlyPrintPriceStatus = () => {
//       this.setState({
//          onlyPrintPrice: !this.state.onlyPrintPrice,
//       });
//    };
//
//    render() {
//       const { invoiceItems, barcodeHeight, barcodeWidth, barcodeFontSize, onlyPrintPrice } = this.state;
//       let toPrint = [];
//       const itemPriceRepeater = function () {
//          invoiceItems.map((item) => {
//             for (let i = 1; i <= item.unit; i++) {
//                toPrint.push({
//                   originalPrice: item.discount ? (item.salePrice + item.discount) : null,
//                   discountedPrice: item.salePrice,
//                });
//             }
//          });
//          return toPrint;
//       };
//       return (
//          <div className="PurchaseInvoiceDetailItem" >
//             <h4>Invoice Items</h4>
//             <Table className={{ 'onlyPrintPrice': onlyPrintPrice }} >
//                <thead>
//                <tr>
//                   <th>Item Id</th>
//                   <th>Item Name</th>
//                   <th>Qty</th>
//                   <th>P.Price</th>
//                   <th>Sale P</th>
//                   <th>Sale Dis</th>
//                   <th>P</th>
//                   <th>Barcode</th>
//                </tr>
//                </thead>
//                <tbody>
//                {invoiceItems.map((item) => (
//                   <tr key={item.id} >
//                      <td className="itemId" >
//                         {item.has_sub_items
//                            ?
//                            <Link target="_blank" to={`/product/productMain/edit/${item.mainItemId}`} >{item.id}</Link>
//                            :
//                            <Link target="_blank" to={`/product/productMain/edit/${item.id}`} >{item.id}</Link>
//                         }
//                      </td>
//                      <td className="itemName" >{item.name}</td>
//                      <td className="itemUnit" >{item.unit}</td>
//                      <td className="purchasePrice" >{item.price}</td>
//                      <td className="salePrice" >{item.salePrice} tk.</td>
//                      <td className="saleDiscount" >{item.discount} tk.</td>
//                      <td className="profitLevel" >{item.profit}</td>
//                      <td>
//                         <Barcode value={item.barcode}
//                                  width={barcodeWidth}
//                                  height={barcodeHeight}
//                                  fontSize={barcodeFontSize}
//                         />
//                      </td>
//                   </tr>
//                ))}
//                </tbody>
//             </Table>
//             <div className="onlyPrintPriceContainer" >
//                <label htmlFor="onlyPrintPrice" >Only Print Price</label>
//                <input onChange={() => this.changeOnlyPrintPriceStatus()} type="checkbox" name="onlyPrintPrice"
//                       id="onlyPrintPrice" value={onlyPrintPrice} />
//             </div>
//
//             <div className="pricePrintContainer" >
//                {itemPriceRepeater().map((toPrint, i) => <span key={i} className="pricePrint" >
//                   {toPrint.originalPrice && <p>{toPrint.originalPrice} tk.</p>}
//                   <p> {toPrint.discountedPrice} tk.</p>
//                   </span>)}
//             </div>
//          </div>
//       );
//    }
// }
//
// PurchaseInvoiceDetailItem.propTypes = {
//    params: PropTypes.object
// };
//
// export default PurchaseInvoiceDetailItem;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/PurchaseInvoiceDetail/PurchaseInvoiceDetailItem.js
 **/